var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.312 22.2927L11.5893 23.1521C11.4396 23.3279 11.1531 23.2888 11.0619 23.074L9.23244 18.7249L3.55512 20.626C3.38585 20.6846 3.27516 20.8343 3.24912 21.0361L2.31809 28.5495C2.23997 29.1615 2.70874 29.6888 3.32074 29.6888H11.0619L12.7873 23.1586L12.312 22.2927Z",
    fill: "#232323"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3601 23.432L11.7129 29.6888H15.6388L13.9916 23.432H13.3601Z",
    fill: "#232323"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4672 23.9594L22.0192 28.1978C21.8825 28.4387 21.5114 28.3866 21.4462 28.1197L21.0426 26.4725L19.4149 26.9413C19.148 27.0194 18.9201 26.7264 19.0568 26.4855L21.2574 22.6768C20.0855 21.8108 19.2521 20.5087 19.0047 19.0112L18.1258 18.7183L16.2963 23.0674C16.2051 23.2822 15.9187 23.3278 15.7689 23.1455L15.0397 22.2926L14.5645 23.1651L16.2898 29.6888H24.031C24.643 29.6888 25.1118 29.1614 25.0401 28.5494L24.4672 23.9594Z",
    fill: "#232323"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5727 18.4058L16.7394 17.5724L14.1025 20.2092L15.9125 22.3577L17.5727 18.4058Z",
    fill: "#232323"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0433 22.807L14.6033 21.7783L13.6722 20.678L12.7412 21.7783L13.3076 22.807H14.0433Z",
    fill: "#232323"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4263 16.9996V15.0854C15.6646 16.0295 14.7075 16.5438 13.7244 16.5438C13.7114 16.5438 13.6918 16.5438 13.6788 16.5438C12.6762 16.5569 11.6996 16.0425 10.9248 15.0854V16.9996L13.6788 19.7536L16.4263 16.9996Z",
    fill: "#232323"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7793 18.4058L11.4395 22.3577L13.2495 20.2092L10.6127 17.5724L9.7793 18.4058Z",
    fill: "#232323"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2575 6.87537C15.3004 7.72827 13.6727 7.71525 11.1661 6.8363C9.64261 7.51993 9.60355 9.19968 9.82491 10.606C10.3458 13.8678 11.8562 15.9513 13.6662 15.9187H13.7248C15.5152 15.9187 17.0062 13.8418 17.5205 10.606C17.7419 9.23223 17.7093 7.58503 16.2575 6.87537Z",
    fill: "#232323"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.12153 9.11506C9.20617 7.66969 9.85073 6.69309 11.0487 6.2113C11.1203 6.18525 11.1984 6.17874 11.2701 6.20479C13.692 7.0642 15.2286 7.09675 15.9643 6.28942C16.0554 6.19176 16.1921 6.16572 16.3093 6.2113C17.5008 6.69309 18.1453 7.66318 18.2365 9.11506C18.4058 9.10855 18.5555 9.12157 18.6857 9.14761C19.135 8.04731 19.161 6.64751 18.7248 5.65789C18.2365 4.55107 17.299 3.72422 16.14 3.37915C16.0554 3.35311 15.9838 3.288 15.9447 3.20987C15.5346 2.29838 13.6334 2.03144 11.8821 2.63693C10.8273 3.00153 7.55246 4.52503 8.47698 9.1997C8.65277 9.13459 8.86111 9.10204 9.12153 9.11506Z",
    fill: "#232323"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53856 12.2011C9.40835 11.7323 9.29766 11.231 9.21302 10.7036C9.16094 10.3651 9.12839 10.046 9.11536 9.74003C8.00855 9.67492 8.01506 10.8468 8.54242 11.5956C8.67264 11.7909 9.01119 12.175 9.53856 12.2011Z",
    fill: "#232323"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2367 9.74004C18.2236 10.046 18.1911 10.3651 18.139 10.7036C18.0544 11.231 17.9437 11.7323 17.8135 12.2011C18.3408 12.175 18.6729 11.7909 18.8096 11.6021C19.3044 10.8989 19.3891 9.67494 18.2367 9.74004Z",
    fill: "#232323"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2947 16.9475L24.6241 15.6128L23.9535 16.9475C23.9079 17.0386 23.8233 17.1037 23.7191 17.1168L22.2412 17.3381L23.3025 18.3863C23.3741 18.458 23.4066 18.5621 23.3936 18.6598L23.1527 20.1312L24.4809 19.4476C24.5265 19.4215 24.572 19.415 24.6241 19.415C24.6762 19.415 24.7218 19.4281 24.7674 19.4476L26.0955 20.1312L25.8546 18.6598C25.8351 18.5621 25.8742 18.458 25.9458 18.3863L27.007 17.3381L25.5291 17.1102C25.4249 17.1037 25.3403 17.0386 25.2947 16.9475Z",
    fill: "#232323"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6236 13.0215C21.8305 13.0215 19.5518 15.2937 19.5518 18.0933C19.5518 20.8929 21.8305 23.1651 24.6236 23.1651C27.4102 23.1651 29.6954 20.8994 29.6954 18.0933C29.6889 15.2937 27.4167 13.0215 24.6236 13.0215ZM27.8854 17.3511L26.4921 18.7248L26.8112 20.652C26.8502 20.9059 26.5833 21.0947 26.3619 20.9775L24.6236 20.0791L22.8852 20.9775C22.6574 21.0947 22.3904 20.8994 22.436 20.652L22.755 18.7248L21.3552 17.3511C21.1729 17.1688 21.2771 16.8563 21.531 16.8172L23.4647 16.5242L24.3436 14.7794C24.4608 14.5515 24.7863 14.5515 24.9035 14.7794L25.7825 16.5242L27.7162 16.8172C27.9636 16.8563 28.0677 17.1688 27.8854 17.3511Z",
    fill: "#232323"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5704 26.0038L21.8699 27.2083L23.8752 23.7316C23.1199 23.6339 22.4103 23.3865 21.7787 23.0154L19.9883 26.121L21.1797 25.7759C21.349 25.7303 21.5248 25.8345 21.5704 26.0038Z",
    fill: "#232323"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3721 23.7381L27.3774 27.2149L27.6769 26.0104C27.7159 25.8411 27.8982 25.7369 28.0675 25.7825L29.2589 26.1276L27.4685 23.022C26.8305 23.3866 26.1273 23.634 25.3721 23.7381Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterActive);
export default __webpack_public_path__ + "static/media/MasterActive.5ac6544b43b691c3d42d7a965346de8c.svg";
export { ForwardRef as ReactComponent };